import { useSelector } from 'react-redux';
import { getCurrentPointIds } from '../../selectors/sended-data';
import React from 'react';

const useHashedPoints = () => {
    const pointListStr = useSelector(getCurrentPointIds);
    const { points, pointHash } = React.useMemo(
        () =>
            pointListStr.split(',').reduce(
                (res, item) => {
                    const [pos, id] = item.split('|');
                    res.points.push(pos);
                    res.pointHash[pos] = +id;

                    return res;
                },
                { points: [], pointHash: {} }
            ),
        [pointListStr]
    );

    return { points, pointHash };
};

export { useHashedPoints };
